<template>
  <section class="w-100 front-section">
    <div class="container-fluid hv-100">
      <div class="row p-md-4 pb-md-0 p-3 pt-5" style="overflow-x:hidden; padding-top: 4rem !important;">
        <div class="border-around-rounded p-3 pb-md-3 pb-1" style="margin-top: 60px; min-height: calc(100vh - 120px);">
          <!-- STANDARD LAYOUT HEADER -->
          <FrontHeader></FrontHeader>
          <div class="py-5 invisible">&nbsp;</div>
          <div class="py-2 invisible d-none d-md-block">&nbsp;</div>

          <!-- CONTENT -->
          <div class="container px-2">
            <div class="text-center mb-5 mt-4">
              <div class="hero-badge mb-3 mx-auto">
                <span class="badge-text">🌟 Top Creators on Stella</span>
              </div>
              <h2 class="section-title text-white">Discover Our <span class="hero-gradient-text">Top Creators</span></h2>
              <p class="section-subtitle font-grey">Connect, interact, and access exclusive content from top talent.</p>
            </div>

            <!-- Loader -->
            <div v-if="isLoading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

            <div v-else class="row justify-content-center">
              <!-- Creator Cards -->
              <div class="col-lg-3 col-md-6 col-12 mb-4" v-for="(creator, i) in creators" :key="i">
                <div class="custom-card-transparent text-center p-4 h-100 d-flex flex-column align-items-center" style="border-radius: 16px; transition: transform 0.3s; cursor: pointer;" onmouseover="this.style.transform='translateY(-5px)'" onmouseout="this.style.transform='translateY(0)'">
                  <div style="width: 100px; height: 100px; border-radius: 50%; overflow: hidden; margin-bottom: 20px; border: 3px solid rgba(255,255,255,0.1);">
                    <img :src="getAvatar(creator)" class="w-100 h-100" style="object-fit: cover;" :alt="creator.name">
                  </div>
                  <h4 class="text-white font-weight-bold">{{ creator.name || 'Anonymous' }}</h4>
                  <div class="text-muted font-size-14 mb-3">{{ getCategory(creator) }}</div>
                  <p class="text-white font-size-13 mb-4" style="opacity: 0.8; flex-grow: 1;">{{ creator.bio || 'Check out my exclusive content on Stella!' }}</p>
                  
                  <button class="btn stella-btn gradient-a w-100 rounded-pill py-2 mt-auto" @click="goToCreator(creator.urlSuffix)">
                    View Profile
                  </button>
                </div>
              </div>

              <!-- Empty State -->
              <div v-if="creators.length === 0" class="col-12 text-center py-5">
                <p class="text-muted">No top creators found at the moment.</p>
              </div>
            </div>

            <div class="py-5 invisible">&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FrontHeader from "@/components/module/front/FrontHeader";
import { AXIOSunsecure } from "@/common/http-common";
import { SERVICE_IDENTIY, SERVICE_CONTENT } from "@/properties/micro-service";
import { filterPublicCreators } from "@/common/creator-access";

export default {
  name: "TopCreators",
  components: {
    FrontHeader
  },
  data() {
    return {
      creators: [],
      isLoading: true
    }
  },
  mounted() {
    this.fetchTopCreators();
  },
  methods: {
    fetchTopCreators() {
      this.isLoading = true;
      // Fetch top 12 influencers from the public API
      AXIOSunsecure().get(SERVICE_IDENTIY + '/api/v1/public/influencers/top?limit=12')
        .then(response => {
          let fetchedCreators = filterPublicCreators(response.data || []);
          // Initialize avatarUrl to null for reactivity
          this.creators = fetchedCreators.map(c => ({
             ...c,
             avatarUrl: null
          }));
          
          // Fetch avatars individually
          this.creators.forEach(creator => {
             this.fetchAvatar(creator);
          });
        })
        .catch(err => {
          console.error("Failed to fetch top creators:", err);
          this.creators = [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    fetchAvatar(creator) {
      AXIOSunsecure().get(`${SERVICE_CONTENT}/api/v1/influencers/urlSuffix/${creator.urlSuffix}/avatar`)
        .then(res => {
          if (res.data) {
            creator.avatarUrl = res.data + '?ver=' + Math.random();
          } else {
            creator.avatarUrl = require('@/assets/images/default_user.png');
          }
        })
        .catch(err => {
          creator.avatarUrl = require('@/assets/images/default_user.png');
        });
    },
    getAvatar(creator) {
      if (creator.avatarUrl) {
        return creator.avatarUrl;
      }
      // Fallback placeholder avatar while loading or if missing
      return require('@/assets/images/default_user.png');
    },
    getCategory(creator) {
      return creator.category || "Creator";
    },
    goToCreator(urlSuffix) {
      if (urlSuffix) {
        this.$router.push(`/${urlSuffix}`);
      }
    }
  }
}
</script>

<style scoped>
.custom-card-transparent {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.05);
}
.hero-gradient-text {
  background: linear-gradient(135deg, #ff6ec7, #7873f5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.stella-btn {
  border: none;
  color: white;
}
.gradient-a {
  background: linear-gradient(135deg, #ff6ec7, #7873f5);
}
.stella-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.hero-badge {
  display: inline-block;
  padding: 6px 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 30px;
}
.badge-text {
  font-size: 13px;
  font-weight: 600;
  color: #e0e0e0;
}
.section-title {
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 1rem;
}
.section-subtitle {
  font-size: 1.1rem;
  max-width: 600px;
  margin: 0 auto;
}
</style>
